import React, { Component } from 'react';
import { connect } from "react-redux";
import { FromToDateFilter, Loader, PrivatePageRedirect, Tooltip } from "../../components";
import { DetailsList, DetailsListLayoutMode, } from 'office-ui-fabric-react/lib/DetailsList';
import { IconButton, Rating, SelectionMode, Toggle } from "office-ui-fabric-react";
import { getSkill } from "../../actions/skills";
import { getProjects, setProject } from "../../actions/projects";
import { Link } from 'react-router-dom';
import { linkify, mapColumnsAndChangeDescendingForExpected, markAsExIfConditionTrue } from '../../service/utils';
import { filterProjectsBySkillId, filterProjectsWithDateRange, sortEmployeeBySkillLevel, sortObjectsWithFieldByAlphabet, sortProjectsByStartDate } from '../../service/filters';

class EmployeesWithSkillPage extends Component {
  state = {
    showDisabled: false,
    fromStart: true,
    skillProjects: [],
    fromDate: null,
    toDate: null,
    employeesWithSkill: [],
    projectColumnSize : 350,
  };

  _employees_columns = [
    {
      key: 'employeeName',
      name: 'Full name',
      fieldName: 'employeeName',
      minWidth: 110,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
      onRender: ({ employeeName, employeeId }) => {
        return <Link
          to={`/home/${employeeId}/profile`}
          className="table-link"
        >{employeeName}</Link>;
      },
    },
    {
      key: 'level',
      name: 'Level',
      fieldName: 'level',
      minWidth: 70,
      maxWidth: 100,
      isResizable: true,
      isPadded: true,
      onRender: ({ level }) => {
        return (<div>
          <Rating
            id={'readOnlyRatingStar'}
            min={1}
            max={5}
            rating={level}
            readOnly={true}
          />
        </div>);
      },
    },
    {
      key: 'projectsCount',
      name: 'No. of projects',
      fieldName: 'projectsCount',
      minWidth: 40,
      maxWidth: 60,
      isResizable: false,
      isPadded: true,
      onRender: ({ projectsCount }) => {
        return (<div style={{ textAlign: 'center' }}>
          {projectsCount}
        </div>);
      },
    },
    {
      key: 'projectNames',
      name: 'Projects',
      fieldName: 'projectNames',
      minWidth: 100,
      maxWidth: 365,
      isResizable: true,
      isPadded: true,

      onRender: (item) => {
        const lines = [];
        let currentLine = [];
        let currentLineLength = 0;
    
        item.projectOptions.forEach((option, index) => {
          const link = (
            <Link
              key={index}
              className="table-link"
              style={{ marginRight: '10px' }}
              activeclassname='underline text-gray-900'
              to={`/home/projects/${option.id}`}
            >
              {option.name}
            </Link>
          );
          if ((currentLineLength + option.name.length) * 6 <= this.state.projectColumnSize) {
            currentLine.push(link);
            currentLineLength += option.name.length;
          } else {
            lines.push(currentLine);
            currentLine = [link];
            currentLineLength = option.name.length;
          }
        });
    
        if (currentLine.length > 0) {
          lines.push(currentLine);
        }
    
        return (
          <div>
            {lines.map((line, index) => (
              <div key={index} style={{ marginBottom: '5px' }}>
                {line}
              </div>
            ))}
          </div>
        );
      },
    },
    {
      key: 'actions',
      name: 'Actions',
      minWidth: 50,
      maxWidth: 50,
      onRender: (item) => {
        return (<IconButton
          style={{ height: 'auto' }}
          allowDisabledFocus={true}
          menuIcon={{ iconName: 'MoreVertical' }}
          menuProps={{
            items: [
              {
                key: 'open',
                text: 'Open profile',
                iconProps: { iconName: 'Contact', style: { color: '#000' } },
                onClick: () => this._openEmployeeProfile(item.employeeId)
              },
              {
                key: 'skills',
                text: 'All skills',
                iconProps: { iconName: 'UserEvent', style: { color: '#000' } },
                onClick: () => this._openEmployeeSkills(item.employeeId)
              }
            ],
            directionalHintFixed: true
          }
          }
          split={false}
        />);
      },
      isPadded: true
    }
  ];

  _projects_columns = [
    {
      key: 'projectName',
      name: 'Project Name',
      fieldName: 'name',
      minWidth: 110,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
      isSorted: true,
      isSortedDescending: false,
      headerClassName: 'clickable-column-header',
      onColumnClick: (ev, column) => {
        this.sortProjectsByProjectName(column.isSortedDescending);
      },
      onRender: (item) => {
        return <Link
          to={`/home/projects/${item.id}`}
          className="table-link"
        >{item.name}</Link>;
      },
    },
    {
      key: 'startDate',
      name: 'Start Date',
      fieldName: 'startDate',
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      isPadded: true,
      isSorted: true,
      isSortedDescending: false,
      headerClassName: 'clickable-column-header',
      onColumnClick: (ev, column) => {
        this.sortProjectsByDate(column.isSortedDescending);
      },
      onRender: ({ startDate }) => {
        return <span>{new Date(startDate).toDateString()}</span>;
      },
    },
    {
      key: 'duration',
      name: 'Duration',
      fieldName: 'durationMonths',
      minWidth: 65,
      maxWidth: 65,
      data: 'string',
      onRender: ({ durationMonths }) => {
        return <span>{durationMonths + ` Month${durationMonths > 1 ? 's' : ''}`}</span>;
      },
      isPadded: true
    },
    {
      key: 'description',
      name: 'Description',
      fieldName: 'description',
      minWidth: 110,
      maxWidth: 250,
      isResizable: true,
      isPadded: true,
      onRender: ({ description }) => {
        return (
          <Tooltip text={description}>{description}</Tooltip>
        );
      },
    },
    {
      key: 'url',
      name: 'Link',
      fieldName: 'url',
      minWidth: 150,
      maxWidth: 350,
      isResizable: true,
      data: 'string',
      onRender: ({ url }) => {
        return <span>{url}</span>;
      },
      isPadded: true
    },
  ];

  componentDidMount() {
    const { user, getSkill, skillId, projects, getProjects } = this.props;
    if (user) {
      getSkill(skillId);
      if (!projects) {
        getProjects();
      }
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { user, getSkill, skillId } = this.props;
    const { skillId: nextId } = nextProps;
    if (skillId !== nextId) {
      if (user) {
        getSkill(nextId);
        if (nextProps.projects) {
          this.setState({
            skillProjects: filterProjectsBySkillId(nextProps.projects, nextId)
          });
        }
      }
    } else {
      if (nextProps.projects) {
        this.setState({
          skillProjects: filterProjectsBySkillId(nextProps.projects, skillId)
        });
      }
      const skill = nextProps.skill
      if (skill && skill.employees) {
        this.setState({employeesWithSkill: this.prepareEmloyeesWithSkill(skill.employees.filter((e) => this.state.showDisabled || !!e.employeeStatus))})
      }
    }

  }

  prepareEmloyeesWithSkill = (employees) => {
    const employeesWithEXMark = employees.map(e => ({ ...e, employeeName: markAsExIfConditionTrue(e.employeeName, !e.employeeStatus) }));
    return sortEmployeeBySkillLevel(employeesWithEXMark);
  }

  filterProjects() {
    const { projects, skillId } = this.props;
    const fromDate = this.state.fromDate;
    const toDate = this.state.toDate;
    if (projects) {
      this.renderColumns("projectName", "startDate", false);
      let fileredProjects = filterProjectsBySkillId(projects, skillId);
      if (fromDate || toDate) {
        fileredProjects = filterProjectsWithDateRange(fileredProjects, fromDate, toDate);
      }
      this.setState({
        skillProjects: fileredProjects
      })
    }
  }

  sortProjectsByProjectName(isSortedDescending) {
    const projects = this.state.skillProjects;
    if (projects) {
      this.renderColumns("projectName", "startDate", !isSortedDescending);
      const pr = sortObjectsWithFieldByAlphabet([...projects], isSortedDescending, "name");
      this.setState({
        skillProjects: pr,
      })
    }
  }

  sortProjectsByDate(isSortedDescending) {
    const projects = this.state.skillProjects;
    if (projects) {
      this.renderColumns("startDate", "projectName", !isSortedDescending);
      const pr = sortProjectsByStartDate([...projects], isSortedDescending);
      this.setState({
        skillProjects: pr,
      })
    }
  }

  renderColumns(columnToRerenderWithValue, columnToReranderWithFalse, value) {
    const mappedColumns = mapColumnsAndChangeDescendingForExpected(this._projects_columns, columnToRerenderWithValue, value);
    this._projects_columns = mapColumnsAndChangeDescendingForExpected(mappedColumns, columnToReranderWithFalse, false);
  }

  render() {
    const { skill: { name, url, category }, projects } = this.props;
    const { showDisabled, skillProjects, fromDate, toDate, employeesWithSkill } = this.state;
    return (
      <div className={'page-container'}>
        <PrivatePageRedirect />
        <span className={'page-title'} style={{ marginBottom: 1 + "rem" }}>Skill: {name ? name : ''}</span>
        {category && category.name && <div className={'page-description'} style={{ padding: 0 }}>Category: {category.name}</div>}
        {url && <p className={'page-description'} dangerouslySetInnerHTML={{ __html: linkify(url) }} />}
        <h3 style={{ fontWeight: 200, marginTop: 3 + "rem" }}>Projects with skill</h3>
        {
          (skillProjects && projects) ?
            <div>
              <div className={'filter-picker'}>
                <FromToDateFilter
                  onFromSelect={(date) => {
                    this.setState({ fromDate: date }, () => {
                      this.filterProjects()
                    });
                  }}
                  fromValue={fromDate}
                  onToSelect={(date) => {
                    this.setState({ toDate: date }, () => {
                      this.filterProjects()
                    });
                  }}
                  toValue={toDate}
                  onReset={() => {
                    this.setState({ toDate: null, fromDate: null }, () => {
                      this.filterProjects()
                    });
                  }}
                />
              </div>
              <DetailsList
                items={skillProjects}
                columns={this._projects_columns}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.justified}
              />
            </div> :
            <Loader title="Loading people with selected skill..." />
        }
        <h3 style={{
          fontWeight: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'row'
        }}>
          Employees with skill
          <Toggle
            styles={{ root: { marginBottom: 0 + 'px' } }}
            aria-describedby={'status-tooltip'}
            className={'employee-status-toggle'}
            onText={'Show disabled'}
            offText={'Show disabled'}
            checked={showDisabled}
            onChanged={this._handleToogleChange}
          />
        </h3>
        {
          employeesWithSkill ?
            <DetailsList
              items={employeesWithSkill}
              columns={this._employees_columns}
              selectionMode={SelectionMode.none}
              layoutMode={DetailsListLayoutMode.justified}
              onColumnResize={(column, newWidth, columnIndex) => {
                if (column.key === "projectNames") this.setState({ projectColumnSize: newWidth});
              }}
            /> :
            <Loader title="Loading people with selected skill..." />
        }
      </div>
    );
  }

  _openEmployeeProfile = (employeeId) => {
    this.props.history.push(`/home/${employeeId}/profile`);
  };

  _openEmployeeSkills = (employeeId) => {
    this.props.history.push(`/home/${employeeId}/skills`);
  };
  _handleToogleChange = (checked) => {
    const {employees} = this.props.skill;
    if (employees) {
      const employeesToShow = this.prepareEmloyeesWithSkill(employees.filter(e => checked || !!e.employeeStatus));
      this._employees_columns = mapColumnsAndChangeDescendingForExpected(this._employees_columns, "employeeName", false);
      this.setState({employeesWithSkill: employeesToShow, showDisabled: checked});
    }
  };
}

const mapStateToProps = ({ user, skill, projects }, { match: { params: { skillId } } }) => {
  return { user, skillId, skill, projects };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProjects: () => dispatch(getProjects()),
    setProject: (project) => dispatch(setProject(project)),
    getSkill: (skillId) => dispatch(getSkill(skillId))
  };
};

export const EmployeesWithSkill = connect(mapStateToProps, mapDispatchToProps)(EmployeesWithSkillPage);



// WEBPACK FOOTER //
// ./src/pages/skills/employeesWithSkillList.js